'use client'

import Image from 'next/image'

import { useConfig } from './ConfigProvider'


export default function Logo({ className }: { className?: string }) {
    const { COMPANY_LOGO } = useConfig()
    return (
        <Image
            alt="Logo"
            className={className || "h-18 w-18"}
            src={`/${COMPANY_LOGO}`}
            width={48}
            height={48}
        />
    )
}
